import Request from '../../common/api/request';
import ServiceResultFactory from '../../common/api/ServiceResultFactory';

const createLead = (baseUrl, locale, exhibitingOrganisationId, eventEditionId, createdOn) => {
  const formattedTimeStamp = createdOn.replace(/[a-zA-Z]/g, ' ').trim();
  const mutation = `
        mutation {
          createConnection(
            exhibitingOrganisationId: "${exhibitingOrganisationId}",
            createdOn : "${createdOn}",
            connectionSource : "Online",
            eventEditionId : "${eventEditionId}",
            metaData : {
              ActivityType : "Contact me"
              LastActivityDate : "${formattedTimeStamp}"
              FirstActivityDate : "${formattedTimeStamp}"
            })
            {
              id
            }
        }`;
  return Request.graphqlRequest(`${baseUrl}/graphql`, mutation)
    .then(response => response.body.data.createConnection)
    .catch(result =>
      ServiceResultFactory.fromError(locale, result, false));
};

const createLeadForProduct = (baseUrl, locale, exhibitingOrganisationId, eventEditionId, createdOn, productId, productTitle) => {
  const formattedTimeStamp = createdOn.replace(/[a-zA-Z]/g, ' ').trim();
  const mutation = `
        mutation {
          createConnection(
            exhibitingOrganisationId: "${exhibitingOrganisationId}",
            createdOn : "${createdOn}",
            connectionSource : "Online",
            eventEditionId : "${eventEditionId}",
            metaData : {
              ActivityType : "Contact me - Video"
              LastActivityDate : "${formattedTimeStamp}"
              FirstActivityDate : "${formattedTimeStamp}"
              Product: {
                Id : "${productId}"
                Title : "${productTitle}" 
              }
            })
            {
              id
            }
        }`;
  return Request.graphqlRequest(`${baseUrl}/graphql`, mutation)
    .then(response => response.body.data.createConnection)
    .catch(result =>
      ServiceResultFactory.fromError(locale, result, false));
};

export default {
  createLead,
  createLeadForProduct
};
